import { schema } from 'normalizr'

export const medicineSchema = new schema.Entity('medicines')
